<template>
  <a-drawer
    title="分发"
    width="700"
    :visible="visible"
    :closable="false"
    @close="onClose"
  >
    <!-- from -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 界面语种 -->
      <a-form-item
        label="界面语种"
        name="lang_ids"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.lang_ids"
          placeholder="请选择"
          mode="multiple"
          show-search
          :disabled="!!recordID"
          :filter-option="filterOption"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <div class="footer-view">
        <span class="footer-hint" v-if="selectKeys.length > 1">共选择了{{ selectKeys.length }} 部短剧</span>
        <div style="flex: 1;"></div>
        <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
        <a-button type="primary" @click="touchSubmit">确定</a-button>
      </div>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import { dramaDistribute, langSearchList } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// from
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 选中的影剧列表
let selectKeys = ref([])
// 编辑的分发记录id
let recordID = ref(undefined)
// 语种列表
let languages= ref([])
// 表单参数
const formState = reactive({
  // 分发语种
  lang_ids: [],
})

// 显示
function showDrawer ({ keys, id }) {
  // 多选新建分发时，用到 keys
  selectKeys.value = keys || []
  // 单个分发记录编辑时，用到id
  recordID.value = id || undefined
  // 显示
  visible.value = true
  // 获取项目列表
  getLanguageList()
}

// 获取界面语种列表
function getLanguageList () {
  langSearchList().then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      languages.value = data
    } else {
      message.error(res.message || msg)
    }
  })
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    visible.value = false
    resetFields()
  }
}

// 重置
function resetFields () {
  RefForm.value.resetFields()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    let params =  {
      lang_ids: formState.lang_ids,
      drama_ids: selectKeys.value,
    }
    dramaDistribute(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.form-input {
  width: 50%;
}
.form-item-clear {
  margin-bottom: 0;
}
.footer-view {
  display: flex;
  align-items: center;
}
.footer-hint {
  color: #5A5A5A;
}
</style>